import type { ReactNode } from 'react';
import { Icon } from './Icon';

const GROUPS: ReadonlyArray<[string, ReadonlyArray<[string, string]>]> = [
    [
        'Find',
        [
            ['/', 'Focus the query'],
            ['⌘ K', 'Find an id, run a command'],
            ['E', 'Next environment'],
            ['T', 'Time range'],
            ['[ ]', 'Zoom out, zoom in'],
            ['R', 'Refresh: the range up to now'],
        ],
    ],
    [
        'Read',
        [
            ['J K', 'Next line, previous line'],
            ['Esc', 'Close the line, the menus'],
            ['L', 'Live tail on and off'],
            ['W', 'Wrap long messages'],
            ['U', 'Rome or UTC'],
            ['P', 'Privacy mode'],
        ],
    ],
    [
        'On a line',
        [
            ['Click', 'A value in the list or the inspector keeps it'],
            ['⌥ Click', 'Excludes it'],
            ['C', 'Copy the link to the open line'],
        ],
    ],
    [
        'Go',
        [
            ['G E', 'Explore'],
            ['G I', 'Issues'],
            ['G P', 'Patterns'],
            ['G B', 'Boards'],
            ['G A', 'Alerts'],
            ['G S', 'Sources'],
        ],
    ],
    [
        'Issues',
        [
            ['J K', 'Next issue, previous issue'],
            ['Enter', 'Open it'],
            ['A', 'Acknowledge'],
            ['R', 'Resolve'],
            ['M', 'Mute for 24 hours'],
            ['/', 'Narrow down'],
        ],
    ],
];

// `?`: every key, on one sheet.
export function Shortcuts(props: { onClose: () => void }): ReactNode {
    return (
        <div className="scrim" onMouseDown={(event) => event.target === event.currentTarget && props.onClose()}>
            <div className="shortcuts float">
                <div className="sheet-head">
                    <div>
                        <h2>Keyboard</h2>
                        <p>Everything also works with the mouse.</p>
                    </div>
                    <button className="closebtn" onClick={props.onClose} title="Close (esc)">
                        <Icon name="x" size={17} />
                    </button>
                </div>
                <div className="sc-body">
                    {GROUPS.map(([title, keys]) => (
                        <div key={title} className="sc-group">
                            <h3>{title}</h3>
                            {keys.map(([key, meaning]) => (
                                <div key={key} className="sc-row">
                                    <span className="kbd">{key}</span>
                                    <span>{meaning}</span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
